"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSfid = exports.getSfidChecksum = void 0;
const checksumAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ012345';
function getSfidChecksum(id) {
    const bin1 = (((~id.charCodeAt(0) >> 5) & 1) << 0) |
        (((~id.charCodeAt(1) >> 5) & 1) << 1) |
        (((~id.charCodeAt(2) >> 5) & 1) << 2) |
        (((~id.charCodeAt(3) >> 5) & 1) << 3) |
        (((~id.charCodeAt(4) >> 5) & 1) << 4);
    var bin2 = (((~id.charCodeAt(5) >> 5) & 1) << 0) |
        (((~id.charCodeAt(6) >> 5) & 1) << 1) |
        (((~id.charCodeAt(7) >> 5) & 1) << 2) |
        (((~id.charCodeAt(8) >> 5) & 1) << 3) |
        (((~id.charCodeAt(9) >> 5) & 1) << 4);
    var bin3 = (((~id.charCodeAt(10) >> 5) & 1) << 0) |
        (((~id.charCodeAt(11) >> 5) & 1) << 1) |
        (((~id.charCodeAt(12) >> 5) & 1) << 2) |
        (((~id.charCodeAt(13) >> 5) & 1) << 3) |
        (((~id.charCodeAt(14) >> 5) & 1) << 4);
    return (checksumAlphabet[bin1] + checksumAlphabet[bin2] + checksumAlphabet[bin3]);
}
exports.getSfidChecksum = getSfidChecksum;
function isValidSfid(id) {
    return id.substring(15, 18) === getSfidChecksum(id);
}
exports.isValidSfid = isValidSfid;
//# sourceMappingURL=sfid.js.map